import React, { useState } from "react";

// Replaces the browser's native black `title`-attribute tooltip (which can't
// be styled at all) with a small custom-styled one, positioned off the real
// mouse coordinates so it works regardless of the SVG's internal coordinate
// space/scaling.
export function useChartTooltip() {
  const [tooltip, setTooltip] = useState(null); // { x, y, text } | null

  const showTooltip = (event, text) => {
    setTooltip({ x: event.clientX, y: event.clientY, text });
  };
  const hideTooltip = () => setTooltip(null);

  return { tooltip, showTooltip, hideTooltip };
}

export function ChartHoverTooltip({ tooltip }) {
  if (!tooltip) return null;

  return (
    <div
      style={{
        position: "fixed",
        left: tooltip.x,
        top: tooltip.y - 12,
        transform: "translate(-50%, -100%)",
        background: "#ffffff",
        color: "#1a1a1a",
        border: "1px solid #eeeeee",
        borderRadius: 8,
        boxShadow: "0 4px 14px rgba(0, 0, 0, 0.12)",
        padding: "6px 10px",
        fontSize: 13,
        fontFamily: "Poppins, sans-serif",
        fontWeight: 500,
        pointerEvents: "none",
        zIndex: 9999,
        whiteSpace: "nowrap",
      }}
    >
      {tooltip.text}
    </div>
  );
}
